import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownMatchCategoryMulti extends Component {

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            tvCategory: []
        };

    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        if (AxiosHeader.getConfig() !== null) {

            let url = process.env.REACT_APP_API_URL+"/LiveMatch/categories";

            if(this.props.applicationid){
                url = process.env.REACT_APP_API_URL+"/ApplicationsManagement/"+this.props.applicationid+"/sport-categories";
            }

            apiClient.get(url, AxiosHeader.getConfig())
                .then(res => {
                    const tvCategory = res.data;
                    const loading = false;
                    this.setState({tvCategory, loading});
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                });
        }else{
            this.props.dispatch(userActions.logoutUnauthorized());
        }
    }

    render() {
        return (
            <Select
                placeholder="Category Select"
                name="categorySelect"
                autoFocus={false}
                multi={true}
                disabled={this.props.loading}
                isSearchable={true}
                value={this.props.categorySelected}
                options={this.state.tvCategory}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownMatchCategoryMulti = connect(mapStateToProps)(DropDownMatchCategoryMulti);
const connectedDropDownMatchCategoryMultiTrans = withNamespaces('common')(connectedDropDownMatchCategoryMulti);
export {connectedDropDownMatchCategoryMultiTrans as DropDownMatchCategoryMulti};
